'use client';

import Link from 'next/link';
import { MailCheck } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/src/shared/ui/button';

type Props = {
  locale: string;
};

export function ForgotPasswordSuccessPanel({ locale }: Props) {
  const t = useTranslations('auth.forgotPassword');

  return (
    <div role="status" className="flex flex-col items-center gap-3 text-center">
      <MailCheck className="size-10 text-primary" aria-hidden />
      <h2 className="text-base font-medium">{t('success.title')}</h2>
      <p className="text-sm text-muted-foreground">{t('success.body')}</p>
      <Button asChild className="mt-2 h-11 w-full rounded-lg text-[14px]">
        <Link href={`/${locale}/login`}>{t('success.go_to_login')}</Link>
      </Button>
    </div>
  );
}
